import React from 'react'
import { Select } from 'antd'

export const statusFilterMethod = (filter, row) => {
  const activeArray = ['New Lead', 'Opportunity', 'Quoted', 'Awarded','Quote Expired']
  const closedArray = [
    'Lost',
    'Declined',
    'Cancelled',
    'Closed (Awarded)',
    'Closed (Declined)',
    'Closed (Lost)',
    'Closed (Cancelled)',
  ]
  if (filter.value === 'all') {
    return true
  }
  if (filter.value === 'awarded') {
    return row[filter.id] === 'Awarded' || row[filter.id] === 'Closed (Awarded)'
  }
  if (filter.value === 'cancelled') {
    return row[filter.id] === 'Cancelled' || row[filter.id] === 'Closed (Cancelled)'
  }
  if (filter.value === 'lost') {
    return row[filter.id] === 'Lost' || row[filter.id] === 'Closed (Lost)'
  }
  if (filter.value === 'quoted') {
    return row[filter.id] === 'Quoted'
  }
  if (filter.value === 'expired') {
    return row[filter.id] === 'Quote Expired'
  }
  if (filter.value === 'opportunity') {
    return row[filter.id] === 'Opportunity'
  }
  if (filter.value === 'newLead') {
    return row[filter.id] === 'New Lead'
  }
  if (filter.value === 'declined') {
    return row[filter.id] === 'Declined' || row[filter.id] === 'Closed (Declined)'
  }

  return filter.value === 'active'
    ? activeArray.includes(row[filter.id])
    : closedArray.includes(row[filter.id])
}

function StatusFilter({ onChange, filter }) {
  return (
    <Select
      onChange={value => onChange(value)}
      style={{ width: '100%' }}
      value={filter ? filter.value : 'all'}>
      <Select.Option value={'active'}>Active</Select.Option>
      <Select.Option value={'closed'}>Closed</Select.Option>
      <Select.Option value={'newLead'}>New Lead</Select.Option>
      <Select.Option value={'opportunity'}>Opportunity</Select.Option>
      <Select.Option value={'quoted'}>Quoted</Select.Option>
      <Select.Option value={'expired'}>Quote Expired</Select.Option>
      <Select.Option value={'awarded'}>Awarded</Select.Option>
      <Select.Option value={'cancelled'}>Cancelled</Select.Option>
      <Select.Option value={'lost'}>Lost</Select.Option>
      <Select.Option value={'declined'}>Declined</Select.Option>
      <Select.Option value={'all'}>All</Select.Option>
    </Select>
  )
}

StatusFilter.propTypes = {}
StatusFilter.defaultProps = {}

export default StatusFilter
